import {Typography} from '@mui/material';
import muiStyled from '@mui/material/styles/styled';

const StyledAccordionTitle = muiStyled(Typography)(({theme}) => ({
  fontSize: 15,
  fontWeight: 'bold',
  color: theme.palette.primary.main
}));

export default StyledAccordionTitle;
